/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon20Regular = forwardRef('TimeClockStopwatchIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6a.75.75 0 0 1 .75.75V11a.75.75 0 0 1-1.5 0V6.75A.75.75 0 0 1 10 6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 0a.75.75 0 0 0 0 1.5h1.75v1.536A8 8 0 1 0 16.161 5.9l1.37-1.369a.75.75 0 0 0-1.061-1.06L15.1 4.839a7.962 7.962 0 0 0-4.35-1.803V1.5h1.75a.75.75 0 0 0 0-1.5h-5ZM3.501 11A6.499 6.499 0 1 1 16.5 11 6.499 6.499 0 0 1 3.5 11Z" })));
});
